module.exports = __webpack_public_path__ + "img/banner_wl.2882bca2.jpg";